import { StyleSheet, ViewProps } from 'react-native'
import { BreadcrumbData } from 'zens-storybook'
import { useWorkspace } from 'zens-store'
import { useTranslation } from 'react-i18next'
import { useBreadcrumb } from '@dms/hook'

import { ReactElement } from 'react'

import { LayoutHeader } from '../layout'

const styles = StyleSheet.create({
  container: {},
})

interface Props extends ViewProps {
  companyId: number
  workspaceId: number
  title?: string | ((name?: string) => string)
  breadcrumbItems?: BreadcrumbData[]
  accessory?: ReactElement
}

const WorkspaceHeader = (props: Props) => {
  const { companyId, workspaceId, title, breadcrumbItems, accessory, style, ...otherProps } = props
  const { t } = useTranslation()
  const workspace = useWorkspace({ companyId, workspaceId })

  const breadcrumb = useBreadcrumb([
    {
      title: t('Workspaces'),
      href: `/companies/${companyId}/workspaces`,
    },
    {
      title: workspace.data?.name || '',
      href: `/companies/${companyId}/workspaces/${workspaceId}`,
    },
    ...(breadcrumbItems || []),
  ])
  return (
    <LayoutHeader
      breadcrumb={breadcrumb}
      title={typeof title === 'string' ? title : title?.(workspace.data?.name) || workspace.data?.name || ' '}
      style={[styles.container, style]}
      accessory={accessory}
      {...otherProps}
    />
  )
}

export default WorkspaceHeader
